import { jsx as _jsx } from "react/jsx-runtime";
import hexToRgba from "hex-to-rgba";
import { StyleSheet, View } from "react-native";
import { useTheme } from "../styles";
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-120}
 */ export function SegmentedProgressBar(param) {
    var length = param.length, progress = param.progress, variant = param.variant, _param_height = param.height, height = _param_height === void 0 ? 12 : _param_height, _param_gap = param.gap, gap = _param_gap === void 0 ? 2 : _param_gap;
    var padding = 4;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(View, {
        style: {
            padding: padding,
            flexDirection: 'row',
            height: height + padding * 2,
            flex: 1,
            gap: gap
        },
        children: Array.from({
            length: length
        }).map(function(_, i) {
            var isFirst = i === 0;
            var isLast = i === length - 1;
            var isPending = i > progress - 1;
            var backgroundColor;
            if (isPending) {
                backgroundColor = variant === 'dark' ? hexToRgba('#FFFFFF', 0.3) : theme.color.accent300;
            } else {
                backgroundColor = variant === 'dark' ? 'white' : theme.color.accent100;
            }
            return /*#__PURE__*/ _jsx(View, {
                style: [
                    {
                        height: '100%',
                        flex: 1,
                        backgroundColor: backgroundColor
                    },
                    isFirst ? styles.first : isLast ? styles.last : undefined
                ]
            }, i);
        })
    });
}
var styles = StyleSheet.create({
    first: {
        borderTopStartRadius: 20,
        borderBottomStartRadius: 20
    },
    last: {
        borderBottomEndRadius: 20,
        borderTopEndRadius: 20
    }
});
